// ABOUTME: Modal that shows the product's outbound instruction the first time a product
// ABOUTME: with one is scanned in an echeck order. Blocks scan input until acknowledged.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

const MEcheckOutboundInstruction = (props) => {
    // props: open, handleClose, sku, instruction
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            props.handleClose();
        }
    };

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
            onKeyDown={handleKeyDown}
            sx={{
                body: {
                    maxWidth:500,
                }
            }}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    pb:3,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    alignItems:'center',
                }}
            >
                <Subheading>{t("instructions")}</Subheading>
                {props.sku && <Text light>{props.sku}</Text>}
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    paddingX:3,
                    paddingTop:3,
                    paddingBottom:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                }}
            >
                <Box
                    sx={{
                        p:2,
                        borderRadius:4,
                        background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                    }}
                >
                    <Text sx={{whiteSpace:"pre-wrap", wordBreak:"break-word"}}>
                        {props.instruction}
                    </Text>
                </Box>
            </Box>

            <Box
                component="footer"
                sx={{
                    pt:2,
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"flex-end",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <ButtonGroup version={2}>
                    <Shbutton
                        autoFocus
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                        variant="contained"
                        onClick={props.handleClose}
                    >
                        {t("confirm")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    );
};

export default MEcheckOutboundInstruction;
